/**
 * Product recommendations
 * 
 * @module product-recommendations
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'collection-slider';

if(!customElements.get(customElements.component)) {
  class CollectionSlider extends HTMLElement {

    connectedCallback() {
      this.initSlider();
    }

    /**
     * Init slider.
     * 
     * @returns {undefined}
    */
    initSlider() {

      this.swiper = this.querySelector('[data-swiper]');
      const swiperMediaPagination = this.querySelector('.swiper-pagination');

      let defaultOptions = {
        preloadImages: true,
        lazy: {
          loadPrevNext: true,
        },
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        pagination: {
          el: swiperMediaPagination,
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-collection-slider-button-next',
          prevEl: '.swiper-collection-slider-button-prev',
        },
        on: {
          afterInit: swiper => {

            setTimeout(() => {
              swiper.slides.forEach( (slide, index) => {
                let productCard = slide.querySelector('product-card');
                if(productCard && productCard.dataset.ready == "false"){
                  swiper.removeSlide(index);
                }
              })
            }, 300);

          }                    
        }
      }

      let options = (this.dataset.options) ? JSON.parse(this.dataset.options) : {};

      this.options = {...defaultOptions, ...options};

      this.slider = new Swiper(this.swiper, this.options);
    }
  }

  customElements.define(customElements.component, CollectionSlider);
}
